<template>
  <div>
    <div class="katta">
      <span>{{ $t("Ходим") }}</span>
      <button
        style="padding: 4px 10px; margin-right: 10px"
        class="btn"
        @click="Prev()"
      >
        <b-icon style="color: white" icon="house-door-fill"> </b-icon>
      </button>
    </div>

    <div class="oyna1">
      <!-- CHAP USTUN -->
      <div class="ustun">
        <div>
          <span>
            {{ $t("Ф.И.Ш") }}
            <span style="color: red;">*</span>
            <span v-if="errors !== null && errors.user_name">
              <span style="color: red; font-size: 9px" v-if="!errors.user_name.required">{{ $t("Ф.И.Ш тўлдирилиши керак") }}</span>
              <span style="color: red; font-size: 9px" v-if="!errors.user_name.minLength">{{ $t("Ф.И.Ш да камида 4 та белги бўлиши керак") }}</span>
            </span>
          </span>
          <b-input v-model="modelvue.user_name" type="text" />
        </div>

        <div>
          <span>
            {{ $t("Хона") }}
            <span style="color: red;">*</span>
            <span v-if="errors !== null && errors.room_id">
              <span style="color: red; font-size: 9px" v-if="!errors.room_id.required">{{ $t("Хона тўлдирилиши керак") }}</span>
            </span>
          </span>
          <v-select
            :options="xonalar"
            label="name"
            :reduce="option => option.id"
            v-model="modelvue.room_id"
          />
        </div>

        <div>
          <span>
            {{ $t("Тўлов тури") }}
            <span style="color: red;">*</span>
            <span v-if="errors !== null && errors.pay_type">
              <span style="color: red; font-size: 9px" v-if="!errors.pay_type.required">{{ $t("Тўлов тури тўлдирилиши керак") }}</span>
            </span>
          </span>
          <v-select :options="tolovTuri" label="name" v-model="modelvue.pay_type" />
        </div>

        <div style="display: flex; justify-content: space-between">
          <div style="width: 49.5%;">
            <div v-if="modelvue.pay_type == 'Oylik'">
              <span>{{ $t("Иш ҳаққи") }}</span>
              <vue-numeric
                style="width: 100%; height: 35px; border: 1px solid #bdb2b2; border-radius: 3px;"
                v-model="modelvue.salary"
                separator="space"
                :precision="2"
              ></vue-numeric>
            </div>
            <div v-if="modelvue.pay_type == 'Foiz'">
              <span>{{ $t("Иш ҳаққи фоизи") }}</span>
              <vue-numeric
                style="width: 100%; height: 35px; border: 1px solid #bdb2b2; border-radius: 3px;"
                v-model="modelvue.percent"
                separator="space"
              ></vue-numeric>
            </div>
          </div>
          <div style="width: 49.5%;">
            <span>{{ "НДС" }}</span>
            <vue-numeric
              style="width: 100%; height: 35px; border: 1px solid #bdb2b2; border-radius: 3px;"
              v-model="modelvue.scot"
              separator="space"
              :precision="2"
            ></vue-numeric>
          </div>
        </div>

        <!-- HIKVISION SOZLAMALARI -->
        <div class="mt-3">
          <b-checkbox v-model="modelvue.to_count_time" :value="true" :unchecked-value="false">
            <b>{{ "Вақтини санаш (Иш ҳақи бўйича jarima)" }}</b>
          </b-checkbox>
        </div>

        <div class="hikvision-container">
          <div 
            v-for="(item, index) in settingsArray" 
            :key="index"
            class="day-card"
            :class="{ 'disabled-card': item.disabled }"
          >
            <b class="day-name">{{ item.name }}</b> <br>
            <b-checkbox
              v-model="item.disabled"
              @change="saveSettings"
              :value="true"
              :unchecked-value="false"
            >
              {{ "Дам олиш" }}
            </b-checkbox>
            <div v-if="!item.disabled">
              <span>{{ "Келиш" }}</span> <br>
              <input type="time" class="time-input" v-model="item.come_time" @input="saveSettings"> <br>
              <span>{{ "Кетиш" }}</span> <br>
              <input type="time" class="time-input" v-model="item.leave_time" @input="saveSettings">
            </div>
          </div>
        </div>

        <div class="mt-2">
          <span>{{ $t("Фаолияти") }}</span>
          <v-select
            :options="condition"
            label="name"
            :reduce="option => option.key"
            v-model="modelvue.condition"
          />
        </div>
      </div>

      <!-- O'NG USTUN -->
      <div class="ustun">
        <div>
          <span>
            {{ $t("Парол") }}
            <span style="color: red;">*</span>
            <span v-if="errors !== null && errors.password">
              <span style="color: red; font-size: 9px" v-if="!errors.password.required">{{ $t("Парол тўлдирилиши керак") }}</span>
              <span style="color: red; font-size: 9px" v-if="!errors.password.minLength">{{ $t("Паролда камида 6 та белги бўлиши керак") }}</span>
            </span>
          </span>
          <b-input v-model="modelvue.password" type="password" placeholder="Yangi parol kiriting..." />
        </div>

        <!-- <div>
          <span>
            {{ $t("Клиника бўлими") }}
            <span style="color: red;">*</span>
            <span v-if="errors !== null && errors.section_id">
              <span style="color: red; font-size: 9px" v-if="!errors.section_id.required">{{ "Клиника бўлими тўлдирилиши керак" }}</span>
            </span>
          </span>
          <v-select
            :options="section"
            label="name"
            :reduce="option => option.id"
            v-model="modelvue.section_id"
          />
        </div> -->

        <div>
          <span>
            {{ $t("Ҳуқуқи") }}
            <span style="color: red;">*</span>
            <span v-if="errors !== null && errors.role">
              <span style="color: red; font-size: 9px" v-if="!errors.role.required">{{ $t("Ҳуқуқи тўлдирилиши керак") }}</span>
            </span>
          </span>
          <v-select :options="category" label="name" v-model="modelvue.role" />
        </div>

        <div v-if="modelvue.role == 'Shifokor'">
          <span>{{ $t("Шифокор") }}</span>
          <v-select
            :options="Shifokor"
            label="name"
            v-model="modelvue.doctor_id"
            :reduce="doctor => doctor.id"
          />
        </div>

        <div v-if="modelvue.role == 'Loborant' || modelvue.role == 'Uzi '">
          <span>{{ $t("Текширув бўlimlari") }}</span>
          <v-select
            :options="tekshiruvBolimlari"
            label="name"
            v-model="modelvue.inspection_category_id"
            :reduce="inspection => inspection.id"
          />
        </div>

        <div v-if="modelvue.role == 'Shifokor'">
          <span>{{ $t("Палата фоиз") }}</span>
          <vue-numeric
            style="width: 100%; height: 35px; border: 1px solid #bdb2b2; border-radius: 3px;"
            v-model="modelvue.palata_percent"
            separator="space"
          ></vue-numeric>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "HodimlarForm",
  props: ["modelvue", "errors"],
  data() {
    return {
      // section: [],
      Shifokor: [],
      tekshiruvBolimlari: [],
      xonalar: [],
      condition: [
        { key: "inaction", name: "Фаолиятда" },
        { key: "notinaction", name: "Фаолиятда эмас" }
      ],
      category: ["Registrator", "Shifokor", "Loborant", "Admin", "Marketolog", "Kasser", "Katta hamshira", "Hamshira", "Xodim"],
      tolovTuri: ["Foiz", "Oylik"],
      settingsArray: [] // Reactive massiv
    };
  },
  watch: {
    // modelvue yuklanganda JSON stringni massivga o'giramiz
    'modelvue.hikvision_setting': {
      immediate: true,
      handler(newVal) {
        if (typeof newVal === 'string') {
          try {
            this.settingsArray = JSON.parse(newVal);
          } catch (e) {
            console.error("JSON parse error", e);
          }
        }
      }
    }
  },
  methods: {
    // Massiv o'zgarganda stringga qayta o'girib modelvue'ga saqlaymiz
    saveSettings() {
      this.modelvue.hikvision_setting = JSON.stringify(this.settingsArray);
      // Parentga ham xabar berish mumkin (ixtiyoriy)
      this.$emit('com_time_change', this.settingsArray);
    },
    Prev() {
      this.$router.push("/hodimlar");
    },
    async fetchData() {
      try {
        const [rooms, inspections, doctors] = await Promise.all([
          axios.get("/room/all"),
          // axios.get("/section/all"),
          axios.get("/inspector_category/all"),
          axios.get("/doctor/all")
        ]);
        this.xonalar = rooms.data.data;
        // this.section = sections.data.data;
        this.tekshiruvBolimlari = inspections.data.data;
        this.Shifokor = doctors.data;
      } catch (e) {
        console.error("Ma'lumotlarni yuklashda xatolik", e);
      }
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style scoped>
.katta {
  background: #007bff;
  margin-top: -25px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 700;
  line-height: 40px;
  border-radius: 8px;
  color: #fff;
  text-indent: 15px;
  box-shadow: 5px 8px 10px rgba(25, 95, 176, 0.5);
}
.oyna1 {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}
.ustun {
  width: 49%;
}
.hikvision-container {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  background: #f9f9f9;
  padding: 10px;
  border-radius: 8px;
}
.day-card {
  border: 1px solid #ccc;
  border-radius: 5pt;
  padding: 8px;
  margin: 5px;
  text-align: center;
  min-width: 125px;
  background: white;
}
.disabled-card {
  background: #ebebeb;
  color: #999;
}
.day-name {
  color: #007bff;
  display: block;
  margin-bottom: 5px;
}
.time-input {
  width: 100%;
  margin-top: 2px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 2px;
}
</style>
